import React from 'react';
import { useIntl } from '@atlassian/jira-intl';
import { MODAL_STATE_IN_PROGRESS } from '../../types';
import InstallationStatusModal from '../installation-status-modal/main.tsx';
import inProgress from './assets/in-progress.png';
import messages from './messages';
import type { Props } from './types';

const InProgressStatusModal = ({ appName }: Props) => {
	const { formatMessage } = useIntl();

	return (
		<InstallationStatusModal
			imageSrc={inProgress}
			heading={formatMessage(messages.heading, { appName })}
			description={formatMessage(messages.body)}
			installationState={MODAL_STATE_IN_PROGRESS}
		/>
	);
};

export default InProgressStatusModal;
